import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"

import { TwoColumn, transformLinkUri } from "gatsby-theme-gba"

const TwoColsEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <TwoColumn
      headline={blok.headline}
      left={
        <Markdown
          source={blok.left}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      }
      right={
        <Markdown
          source={blok.right}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      }
      mobileLeftBackground={blok.mobileLeftBackground}
      mobileRightBackground={blok.mobileRightBackground}
    />
  </SbEditable>
)

export default TwoColsEditable
